var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleQuestionMark = function SvgCircleQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1871E0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.124 7.708c0-.69.56-1.25 1.25-1.25h1.008a1.493 1.493 0 0 1 .828 2.735l-.469.312c-.463.31-.742.83-.742 1.387v.15m0 2.291v-.008M17.708 10A7.708 7.708 0 1 1 2.29 10a7.708 7.708 0 0 1 15.417 0m-7.5 3.333a.208.208 0 1 1-.417 0 .208.208 0 0 1 .417 0"
  })));
};
export default SvgCircleQuestionMark;